export const isSlug = (merchantId?: string) => merchantId?.includes('-') || merchantId?.length !== 13 || undefined;
